import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { site } from "@/config";
import { EASE } from "@/components/Reveal";

const links = [
  { label: "About", href: "#about" },
  { label: "Work", href: "#work" },
  { label: "Process", href: "#process" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

const scrollTo = (e, href) => {
  e.preventDefault();
  window.__lenis?.scrollTo(href, { offset: -72 });
};

export default function Navbar() {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/70 border-b border-black/5"
    >
      <nav className="flex items-center justify-between px-6 sm:px-12 h-[72px]">
        <a
          href="#top"
          onClick={(e) => scrollTo(e, "#top")}
          data-testid="nav-logo"
          className="font-display font-bold text-lg tracking-tight"
        >
          {site.initials}
          <span className="text-primary">.</span>
        </a>
        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => scrollTo(e, l.href)}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="link-sweep font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </div>
        <a
          href={site.calendlyUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-book-call-btn"
          className="group inline-flex items-center gap-2 bg-primary text-primary-foreground font-mono text-xs tracking-[0.15em] uppercase px-5 py-3 rounded-full hover:scale-105 hover:shadow-[0_6px_24px_rgba(0,113,227,0.35)] transition-[transform,box-shadow] duration-300"
        >
          Book a call
          <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </nav>
    </motion.header>
  );
}
